'use strict';

export function routeConfig($urlRouterProvider, $locationProvider) {
  'ngInject';

  $urlRouterProvider.otherwise('/');

  $locationProvider.html5Mode(true);
}

export function decorateTextAngular($provide){
  'ngInject';

  $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function(taRegisterTool, taOptions){

    taRegisterTool('backgroundColor', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" +
        "<button title='Background Color' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><span style='color:black; background-color:yellow'>ABC</span><i class='fa fa-caret-down'></i></button>" +
        "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='width: 100%' type='button' ng-click='action($event, o.css)'><div style='border:1px solid black; float:left; width:20px; background-color: {{o.css}}; '>&nbsp;</div>&nbsp;&nbsp;<i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
      action: function (event, color) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('backColor', color);
      },
      options: [
        { name: 'Aqua', css: "aqua" },
        { name: 'Black', css: "black" },
        { name: 'Blue', css: "blue" },
        { name: 'Fuchsia', css: "fuchsia" },
        { name: 'Gray', css: "gray" },
        { name: 'Green', css: "green" },
        { name: 'Lime', css: "lime" },
        { name: 'Maroon', css: "maroon" },
        { name: 'Navy', css: "navy" },
        { name: 'Olive', css: "olive" },
        { name: 'Purple', css: "purple" },
        { name: 'Red', css: "red" },
        { name: 'Silver', css: "silver" },
        { name: 'Teal', css: "teal" },
        { name: 'White', css: "white" },
        { name: 'Yellow', css: "yellow" }
      ]
    });

    taRegisterTool('fontColor', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" +
        "<button title='Text Color' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><span style='color:red'>A</span><span style='color:green'>B</span><span style='color:blue'>C</span><i class='fa fa-caret-down'></i></button>" +
        "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='width: 100%' type='button' ng-click='action($event, o.css)'><div style='border:1px solid black; float:left; width:20px; background-color: {{o.css}}; '>&nbsp;</div>&nbsp;&nbsp;<i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
      action: function (event, color) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('foreColor', color);
      },
      options: [
        { name: 'Aqua', css: "aqua" },
        { name: 'Black', css: "black" },
        { name: 'Blue', css: "blue" },
        { name: 'Fuchsia', css: "fuchsia" },
        { name: 'Gray', css: "gray" },
        { name: 'Green', css: "green" },
        { name: 'Lime', css: "lime" },
        { name: 'Maroon', css: "maroon" },
        { name: 'Navy', css: "navy" },
        { name: 'Olive', css: "olive" },
        { name: 'Purple', css: "purple" },
        { name: 'Red', css: "red" },
        { name: 'Silver', css: "silver" },
        { name: 'Teal', css: "teal" },
        { name: 'White', css: "white" },
        { name: 'Yellow', css: "yellow" }
      ]
    });

    taRegisterTool('fontName', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" +
        "<button title='Font Face' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><i class='fa fa-font'></i><i class='fa fa-caret-down'></i></button>" +
        "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='font-family: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.css)'><i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
      action: function (event, font) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('fontName', font);
      },
      options: [
        { name: 'Sans-Serif', css: 'Arial, Helvetica, sans-serif' },
        { name: 'Serif', css: "'times new roman', serif" },
        { name: 'Wide', css: "'arial black', sans-serif" },
        { name: 'Narrow', css: "'arial narrow', sans-serif" },
        { name: 'Comic Sans MS', css: "'comic sans ms', sans-serif" },
        { name: 'Courier New', css: "'courier new', monospace" },
        { name: 'Garamond', css: 'garamond, serif' },
        { name: 'Georgia', css: 'georgia, serif' },
        { name: 'Tahoma', css: 'tahoma, sans-serif' },
        { name: 'Trebuchet MS', css: "'trebuchet ms', sans-serif" },
        { name: "Helvetica", css: "'Helvetica Neue', Helvetica, Arial, sans-serif" },
        { name: 'Verdana', css: 'verdana, sans-serif' },
        { name: 'Proxima Nova', css: 'proxima_nova_rgregular' }
      ]
    });

    taRegisterTool('fontSize', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px'>" +
        "<button title='Font Size' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><i class='fa fa-text-height'></i><i class='fa fa-caret-down'></i></button>" +
        "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='font-size: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.value)'><i ng-if='o.active' class='fa fa-check'></i> {{o.name}}</a></li></ul>" +
        "</span>",
      action: function (event, size) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('fontSize', parseInt(size));
      },
      options: [
        { name: 'XX Small', css: 'xx-small', value: 1 },
        { name: 'X Small', css: 'x-small', value: 2 },
        { name: 'Small', css: 'small', value: 3 },
        { name: 'Medium', css: 'medium', value: 4 },
        { name: 'Large', css: 'large', value: 5 },
        { name: 'X Large', css: 'x-large', value: 6 },
        { name: 'XX Large', css: 'xx-large', value: 7 }

      ]
    });

    // add the button to the default toolbar definition
    //taOptions.toolbar[1].push('backgroundColor','fontColor','fontName','fontSize');
    return taOptions;
  }]);
}

export function addCustomFieldsCache($templateCache) {
  $templateCache.put("components/schema-form-custom-fields/entity-lookup.html",
    `<div class="{{form.fieldHtmlClass}}"> <!-- Surrounding DIV for sfField builder to add a sfField directive to. -->
    <label>{{form.title}}</label>

    <div class="input-group">
        <select class="form-control" ng-options="o.value as o.name group by o.group for o in form.schema.entityLookupData | orderBy:['group','name']"
        sf-field-model schema-validate="form"></select>
        <span class="input-group-btn">
              <a  class="btn btn-default" ng-click="form.schema.fnLookup(form.key)" type="button"><i class="fa fa-fw fa-search"></i></a>

              <a ng-if="form.key.length == 1" class="btn btn-danger" ng-disabled="!model[form.key[0]]" href="#" ng-click="model[form.key[0]] = undefined"><i class="fa fa-fw fa-times"></i></a>
              <a ng-if="form.key.length == 2" class="btn btn-danger" ng-disabled="!model[form.key[0]][form.key[1]]" href="#" ng-click="model[form.key[0]][form.key[1]] = undefined"><i class="fa fa-fw fa-times"></i></a>
              <a ng-if="form.key.length == 3" class="btn btn-danger" ng-disabled="!model[form.key[0]][form.key[1]][form.key[2]]" href="#" ng-click="model[form.key[0]][form.key[1]][form.key[2]] = undefined"><i class="fa fa-fw fa-times"></i></a>
              <a ng-if="form.key.length == 4" class="btn btn-danger" ng-disabled="!model[form.key[0]][form.key[1]][form.key[2]][form.key[3]]" href="#" ng-click="model[form.key[0]][form.key[1]][form.key[2]] = undefined"><i class="fa fa-fw fa-times"></i></a>
        </span>
    </div>

    <div class="help-block" sf-message="form.description"></div>
</div>`);

  $templateCache.put("components/schema-form-custom-fields/entity-lookup-no-dropdown.html",
    `<div class="{{form.fieldHtmlClass}}"> <!-- Surrounding DIV for sfField builder to add a sfField directive to. -->
    <label>{{form.title}}</label>

    <div class="input-group">
        <select class="form-control" disabled="disabled" ng-options="o.value as o.name for o in form.schema.entityLookupData"
        sf-field-model schema-validate="form"></select>
        <span class="input-group-btn">
              <a  class="btn btn-default" ng-click="form.schema.fnLookup(form.key)" type="button"><i class="fa fa-fw fa-search"></i></a>

              <a ng-if="form.key.length == 1" class="btn btn-danger" ng-disabled="!model[form.key[0]]" href="#" ng-click="model[form.key[0]] = undefined"><i class="fa fa-fw fa-times"></i></a>
              <a ng-if="form.key.length == 2" class="btn btn-danger" ng-disabled="!model[form.key[0]][form.key[1]]" href="#" ng-click="model[form.key[0]][form.key[1]] = undefined"><i class="fa fa-fw fa-times"></i></a>
              <a ng-if="form.key.length == 3" class="btn btn-danger" ng-disabled="!model[form.key[0]][form.key[1]][form.key[2]]" href="#" ng-click="model[form.key[0]][form.key[1]][form.key[2]] = undefined"><i class="fa fa-fw fa-times"></i></a>
              <a ng-if="form.key.length == 4" class="btn btn-danger" ng-disabled="!model[form.key[0]][form.key[1]][form.key[2]][form.key[3]]" href="#" ng-click="model[form.key[0]][form.key[1]][form.key[2]] = undefined"><i class="fa fa-fw fa-times"></i></a>
        </span>
    </div>

    <div class="help-block" sf-message="form.description"></div>
</div>`);

}

export function schemaFormCustomFields(schemaFormDecoratorsProvider, sfBuilderProvider) {
  schemaFormDecoratorsProvider.defineAddOn(
    'bootstrapDecorator',         // Name of the decorator you want to add to.
    'entitylookup',                    // Form type that should render this add-on
    'components/schema-form-custom-fields/entity-lookup.html',    // Template name in $templateCache
    sfBuilderProvider.stdBuilders // List of builder functions to apply.
  );

  schemaFormDecoratorsProvider.defineAddOn(
    'bootstrapDecorator',         // Name of the decorator you want to add to.
    'entitylookup-nodropdown',                    // Form type that should render this add-on
    'components/schema-form-custom-fields/entity-lookup-no-dropdown.html',    // Template name in $templateCache
    sfBuilderProvider.stdBuilders // List of builder functions to apply.
  );
}

export function addSingleFileUploadCache($templateCache) {
  $templateCache.put("components/schema-form-single-file-upload/single-file-upload.html",
    `<div> <!-- Surrounding DIV for sfField builder to add a sfField directive to. -->
    <label>{{form.title}}</label>

      <div ng-if="model[form.key[0]]">
        <div class="well well-sm">
            <a ng-href="/api/storage/{{model[form.key[0]]}}" target="_blank"><i class="fa fa-fw fa-download"></i> Download</a>
            <a class="btn btn-sm btn-danger pull-right" style="position: relative; top: -5px;"
                ng-click="model[form.key[0]] = undefined"><i class="fa fa-fw fa-trash"></i></a>
        </div>
      </div>

      <div ng-if="!model[form.key[0]]">
        <a class="btn btn-sm btn-primary" ng-click="form.schema.fnOpenAssetUploadModal(form.key[0])"><i class="fa fa-fw fa-upload"></i> Upload</a>
      </div>


    <div class="help-block" sf-message="form.description"></div>
</div>`);

}

export function schemaFormSingleFileUpload(schemaFormDecoratorsProvider, sfBuilderProvider) {
  schemaFormDecoratorsProvider.defineAddOn(
    'bootstrapDecorator',         // Name of the decorator you want to add to.
    'single-file-upload',                    // Form type that should render this add-on
    'components/schema-form-single-file-upload/single-file-upload.html',    // Template name in $templateCache
    sfBuilderProvider.stdBuilders // List of builder functions to apply.
  );
}




// WEBPACK FOOTER //
// ./client/app/app.config.js